import React from 'react';

import { MapTo } from '@adobe/aem-spa-component-mapping';

import { BulletList } from 'components/ExpertSearch/components/BulletList/BulletList';
import { MailHotline } from 'components/ExpertSearch/components/MailHotline/MailHotline';
import { PageTitleSection } from 'components/PageTitleSection/PageTitleSection';

export const Einspeiseranschluss = () => {
  return (
    <div className="expert-page einspeiseranschluss">
      <div className="expert-page-content-stage-text">
        <PageTitleSection title="Einspeiseranschluss" notFramed />
        <MailHotline>
          <p>
            Postfach:{' '}
            <a href="mailto:inspeiseranschluss@lew-verteilnetz.de">
              einspeiseranschluss@lew-verteilnetz.de
            </a>
          </p>

          <p>Hotline: 0821/328-2971 (bei komplexen Fragen ist eine Email zu bevorzugen)</p>
        </MailHotline>

        <BulletList
          title="Themen"
          items={
            <>
              <li>
                Technische Fragen zu Erzeugungsanlagen (keine wirtschaftlichen Fragestellungen)
              </li>
              <li>
                Technische Fragen zu Umstellungen von Erzeugungsanlagen Post EEG oder laufende
                Anlagen
              </li>
              <li>Statusabfragen zu Vorgängen</li>
              <li>Speicherthemen</li>
              <li>Fragen zu Netzberechnung</li>
              <li>Fragen zu Messkonzepten</li>
              <li>Altvorgänge im IPN die auf „Einspeiser“ stehen</li>
              <li>
                Fragen zu abgelehnten Aufträgen z.B. unvollständige Unterlagen, fehlende Angaben,
                technische Ablehnungen
                <ul>
                  <li>Bitte die Ablehnungsbegründung prüfen und ggf. Auftrag anpassen</li>
                </ul>
              </li>
              <li>Datenänderungen bei laufenden Anmeldungen</li>
            </>
          }
        />
        <BulletList
          title="Was gehört nicht zum Einspeiseranschluss"
          items={
            <>
              <li>Vergütungsfragen (z.B. Modultausch, Vergütung von Erweiterungen)</li>
              <li>Abrechnungsfragen</li>
              <li>Freileitungsisolierungen</li>
              <li>Bankdatenänderungen / Steueränderungen</li>
              <li>
                Allgemeine Vertragsänderungen zu bestehenden Einspeiseanlagen (ausgenommen
                Umstellungen von Anlagen)
              </li>
              <li>Rücksendung vergütungsrelevante Unterlagen</li>
              <li>Rückfragen zu Wallboxen und ggf. Wärmepumpen</li>
              <li>Meldung Zählerstände</li>
              <li>Nachfragen zum fehlenden Zählertausch/ Zählereinbau</li>
              <li>Steuerbox, …</li>
              <li>Fragen zu Liefertermin u. Test/Inbetriebnahme von Fernsteuerungen</li>
            </>
          }
        />
        <PageTitleSection title="Einspeiserabrechnung" notFramed />
        <MailHotline>
          <p>
            Postfach:{' '}
            <a href="mailto:abrechnung-einspeiser@lew-verteilnetz.de">
              abrechnung-einspeiser@lew-verteilnetz.de
            </a>
          </p>

          <p>Hotline: 0821/328-1865</p>
        </MailHotline>
        <BulletList title="Themen" items={<li>Fragen zur Einspeiseabrechnung</li>} />
      </div>
    </div>
  );
};
MapTo('e-fix/components/content/einspeiseranschluss')(Einspeiseranschluss);
